import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import 'fixed-sticky';
import BrowseBar from 'component_ui/browse-bar';
import BrowseDesignsData from 'component_data/browse-designs';
import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown';
import DesignGrid from 'component_ui/design-grid';
import FilterList from 'component_ui/filter-list';
import FreezeScrolling from 'component_ui/freeze-scrolling';
import LikeData from 'component_data/like';
import LikeButton from 'component_ui/like';
import MegaDrawer from 'component_ui/mega-drawer';
import Pagination from 'component_ui/pagination';
import ScrollDistanceTrigger from 'component_ui/scroll-distance-trigger';
import SmallScreenOffCanvasFilters from 'component_ui/small-screen-off-canvas-filters';
import TagFilter from 'component_ui/tag-filter';
import UpdateProperty from 'component_ui/update-property';
import UpdateText from 'component_ui/update-text';
import DropdownRepositioner from 'component_ui/dropdown-repositioner';
import HtmlUpdater from 'component_ui/html-updater';
import trackEvent from '@99designs/common/utils/platform/trackEvent';
import debounce from 'lodash.debounce';
import bugsnag from '@99designs/common/utils/platform/bugsnag';

$(() => {
    $(document).on('click', function(e) {
        $(this).trigger('uiCloseMultiSelectDropdown', { target: e.target });
        $(this).trigger('uiCloseSelectDropdown', { target: e.target });
        $(this).trigger('uiHideToggleVisible', { target: e.target });
        $(this).trigger('uiBodyClick', { target: e.target });
    });

    const inspirationCollectorEnabled =
        window.inspirationCollector === 'enabled' && !window.isUserLoggedIn;

    if (window.inspirationCollector === 'enabled') {
        initInspirationCollector();
    }

    function initInspirationCollector() {
        if (typeof window.mountInspirationCollector === 'function') {
            window.mountInspirationCollector('inspiration-collector', {
                isUserLoggedIn: window.isUserLoggedIn,
            });
        } else {
            bugsnag.notify(
                new Error('Inspiration Collector microfrontend failed to mount in discover page')
            );
        }
    }

    BrowseBar.attachTo('[data-browse-bar]');

    BrowseDesignsData.attachTo(document, {
        baseUrl: '/discover',
        xhrUrl: '/discover/xhr/designs',
        filterTypes: {
            category: 'array',
            industry: 'array',
            tags: 'array',
            'admin-tags': 'array',
            language: 'array',
            'max-age': '',
            page: '',
            'your-likes': '',
        },
    });

    DesignGrid.attachTo('[data-design-grid]');

    const dropdowns = DetachedDropdown.createAll('[data-detached-dropdown]');

    FilterList.attachTo('[data-filter-list]');

    // Always position sticky with javascript, not CSS
    // https://github.com/filamentgroup/fixed-sticky#using-the-polyfill-instead-of-native
    window.FixedSticky.tests.sticky = false;
    $('[data-mega-drawer]').fixedsticky();

    $('[data-flight-like-button]').each(function() {
        LikeData.attachTo(this, {
            likeUrl: $(this).data('like-url'),
        });
    });

    FreezeScrolling.attachTo('body', {
        scrollingSelector: '[data-scroll-freeze]',
    });

    $('[data-small-screen-off-canvas-filters-button]').on('click', function() {
        const $self = $(this);
        $(document).trigger('uiActivateSmallScreenOffCanvasFilters', {
            name: $self.attr('data-small-screen-off-canvas-filters-button-name'),
        });
    });

    $('[data-login-signup-like-button]').on('click', () => {
        trackEvent('Clicked Like Icon or Like Filter On Discover Page', {
            location: 'discover',
            feature: 'Like Icon',
        });
        $(document).trigger('uiLikeButtonClicked');
    });

    $('[data-tag-input]').on(
        'keyup',
        debounce(function(e) {
            const searchTerm = e.target.value;
            if (searchTerm) {
                trackEvent('Performed Search', {
                    location: 'discover',
                    searchTerm: searchTerm,
                });
            }
        }, 200)
    );

    $('[data-tag-suggestions-list]').on('click', function(e) {
        trackEvent('Selected Search Result', {
            location: 'discover',
            search_term: e.target.textContent.trim(),
        });
    });

    $('[data-login-signup-your-likes]').on('click', function() {
        trackEvent('Clicked Like Icon or Like Filter On Discover Page', {
            location: 'discover',
            feature: 'Like Filter',
        });
    });

    $('[name="your-likes-disabled"]').on('click', function() {
        $(document).trigger('likeFilterClickedWithoutLogin');
        return false;
    });

    $('[name="your-likes"]').on('change', function() {
        trackEvent('Clicked Show Your Liked Designs', {
            enabled: this.checked,
        });
    });

    LikeButton.attachTo('[data-flight-like-button]', { inspirationCollectorEnabled });

    $('[data-flight-like-button]').on('click', e => {
        const parentElement =
            $(e.target).attr('data-flight-like-button') !== undefined
                ? $(e.target)
                : $(e.target).parent();

        const liked = $(parentElement).attr('data-liked') === 'true';

        trackEvent('Clicked Like Button On Discover Page', {
            liked,
        });
        e.preventDefault();
    });

    ScrollDistanceTrigger.attachTo(window, {
        triggeredEvent: 'uiCloseMegaDrawer',
        triggerAfterDistance: 250,
        resetTime: 1000,
    });

    SmallScreenOffCanvasFilters.attachTo('[data-small-screen-off-canvas-filters]');

    TagFilter.attachTo('[data-tag-editor-design-tags]', {
        filterName: 'tags',
    });

    MegaDrawer.attachTo('[data-mega-drawer]', {
        defaultTab: 'category',
    });

    Pagination.attachTo('[data-pagination]');

    UpdateText.attachTo('[data-update-text="header"]', {
        dataKey: 'page_header_text',
        eventName: 'dataPageHeaderUpdate',
        fade: false,
    });

    UpdateText.attachTo('head > title', {
        dataKey: 'page_title_text',
        eventName: 'dataPageHeaderUpdate',
        fade: false,
    });

    UpdateText.attachTo('head > meta[property="og:title"]', {
        dataKey: 'page_title_text',
        eventName: 'dataPageHeaderUpdate',
        fade: false,
    });

    UpdateText.attachTo('[data-filtered-design]', {
        dataKey: 'filtered_designs_count',
        eventName: 'filteredDesignsCountUpdate',
    });

    UpdateProperty.attachTo('head > meta[name="twitter:title"]', {
        dataKey: 'page_title_text',
        eventName: 'dataPageHeaderUpdate',
        property: 'content',
    });

    $('[data-tag-input]').on('change', e => {
        e.preventDefault();
    });

    HtmlUpdater.attachTo('[data-login-signup-container-your-likes]', {
        eventName: 'likeFilterClickedWithoutLogin',
        templateSelector: '[data-update-html-template="login-or-signup"]',
    });

    DropdownRepositioner.attachTo('[data-login-signup-your-likes]', {
        eventName: 'likeFilterClickedWithoutLogin',
        dropdowns,
    });

    HtmlUpdater.attachTo('[data-login-signup-container]', {
        eventName: 'uiLikeButtonClicked',
        templateSelector: '[data-update-html-template="login-or-signup"]',
    });

    DropdownRepositioner.attachTo('[data-login-signup-like-button]', {
        eventName: 'uiLikeButtonClicked',
        dropdowns,
    });
});



// WEBPACK FOOTER //
// ./src/js/page/discover-designs.js